import { useEffect } from 'react';
import { UnknownFunction } from 'types/types';

const useEnterPress = (action: UnknownFunction, dependencies: unknown[] = []) => {
  useEffect(() => {
    const listenEnterPress = (event: KeyboardEvent) => {
      if ((event.key !== 'Enter' && event.key !== 'NumpadEnter') || event.shiftKey) return;
      event.stopPropagation();
      event.preventDefault();

      action();
    };

    document.addEventListener('keydown', listenEnterPress);

    return () => {
      document.removeEventListener('keydown', listenEnterPress);
    };
  }, [action, ...dependencies]);
};

export default useEnterPress;
